/* eslint-disable no-console */
// eslint-disable-next-line import/no-cycle
import { Firebase } from 'services';
import { NBXStorage } from '@nbx/frontend-helpers/storage';
import { post } from '@nbx/frontend-helpers/fetch-api';
import { context, removeDeviceToken, isDeviceTokenExists } from '@nbx/frontend-helpers/auth';
import { ApplePayWalletExtension } from '@nbx/capacitor-apple-pay';
import {
  publishAuthUserChanged,
  publishAuthSessionChanged,
  publishAuthAccountIdChanged,
  publishAuthUserClaimsChanged
} from '@nbx/frontend-helpers/publish';
import { privateStore } from 'fetch/stores';

let baseUrl = 'auth';

// Names, not instanceof: helpers can resolve to a second copy inside a federated microfrontend.
const isSessionAlreadyGone = error =>
  error?.name === 'SessionTokenError' || [401, 403].includes(error?.response?.status);

const runLogout = () =>
  context
    .session()
    .then(session => post(`${baseUrl}/logout`, {}, session))
    .catch(error => {
      // A session the server no longer accepts is the goal of logging out, not a failure.
      if (!isSessionAlreadyGone(error)) console.error(error);
    })
    .finally(async () => {
      publishAuthSessionChanged(null);
      publishAuthAccountIdChanged(null);
      publishAuthUserChanged(null);
      publishAuthUserClaimsChanged({ roles: [] });
      window.DD_RUM?.clearUser(); // NOTE: using imported datadogRum is not working properly

      console.log('auth.service: LOGOUT');

      // On mobile, we need to explicity preserve theme & lang to avoid broken appearance
      // On web, these values are stored in localStorage (instead of sessionStorage), and so are never cleared
      if (window.PLATFORM === 'ios' || window.PLATFORM === 'android') {
        const keysResult = await NBXStorage.keys();
        keysResult.keys.forEach(key => {
          if (!['theme', 'i18nextLng'].includes(key)) {
            NBXStorage.removeItem(key);
          }
        });
        try {
          console.log('auth.service: LOGOUT - removeItemSecure');
          await removeDeviceToken();
          if (window.PLATFORM === 'ios') {
            await ApplePayWalletExtension.clear();
          }
          if (await isDeviceTokenExists()) console.log('token was not removed');
        } catch (e) {
          console.error(`Failed removeItemSecure [${window.PLATFORM}]`, e.message);
        }
      } else {
        NBXStorage.clear();
      }

      Firebase.logout();
      // clear fetch cache of private user info
      if (window.CAN_CACHE_IDB) privateStore.clear();
    });

let logoutInFlight = null;

const NBXAuth = {
  init: config => ({ baseUrl } = config),

  // The token refreshers can fail together; without this they fire two /auth/logout calls and the
  // second one 403s on the session the first already ended.
  logout: () => {
    if (!logoutInFlight) {
      logoutInFlight = runLogout().finally(() => {
        logoutInFlight = null;
      });
    }
    return logoutInFlight;
  }
};

export default NBXAuth;
